var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sui-segment',{staticClass:"login-view",attrs:{"loading":_vm.silentLoginLoading}},[(_vm.error)?_c('sui-message',{attrs:{"negative":""}},[_vm._v(" "+_vm._s(_vm.errorMessage)+" ")]):_vm._e(),_c('AuthButton',{ref:"authButton"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }